import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { Backdrop, CircularProgress, makeStyles } from '@material-ui/core';
import { getRouterList } from './router';
import {
  screenResizeAction,
  updateWardinfoAction,
  SetUnEdit,
  SetNotificationTotal,
  InitForwardList,
  closeAdmissionWorkflow,
  openAdmissionWorkflow,
  SetAppreciationTotal
} from './redux/actions/';
import './static/css/global.css';
import { setRouterRef } from './utils/router';
import { envFunc } from './utils/environments';
import { checkIsNewDrive, checkRedirectUrl } from './utils/check';
import { WarpRoute as Route } from './router/comm';
import { updateUserRoleAction } from './redux/actions/userRole';
import { setEnv } from './redux/actions/env';
import { userRoleFunc, userRoleList } from './utils/userRole';
import { eadmissionAPI, systemAPI, patientSurveyAPI } from './apis';
import { updateRouListAction } from './redux/actions/rouList';
import { initLoginInfoAction, updateLoginInfoAction } from './redux/actions/loginInfo';
import { updateRoleMapAction } from './redux/actions/roleMap';
import { roleMapFunc,authNameE } from './utils/userFuncs';
import { hospitalWardListFunc } from './utils/hospitalWardList';
import { updateHospitalWardListAction } from './redux/actions/hospitalWardList';
import UserLeaveConfirmation from './components/UserLeaveConfirmation';
import { LOGIN_INFO, NOTIFICATION_INTERVAL, WARD_INFO, APPRECIATION_INTERVAL } from './comm/constant';
import { useGetUserInfo } from './utils';
import useBarcodeScanner from './utils/useBarcodeScanner';
import { useLoadTranslations } from './language';
import { initBsAlereAudio } from './utils/bsAlertUtil';
import { enterFullscreen, exitFullscreen } from './utils/newBedStatusUtil';
import useBsViewSetting from './utils/useBsViewSetting';
import GlobalRouteChangeHandler from './components/GlobalRouteChangeHandler';
import { mutationUpdateOtherLoginInfo, useUpdateOtherLoginInfo } from './utils/handleUpdateOtherLoginInfo';
import IdleChecker from './components/IdleChecker';
import VersionChecker from './components/VersionChecker';
import { useActionableAudioOpen } from './utils/hooks';
import ServiceChecker from './components/ServiceChecker';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.tooltip + 1,
    color: theme.palette.primary.main,
  },
}));

export const App = ({
  updateRoleMap,
  isLoading,
  loginInfo,
  wardInfo,
  userRole,
  updateUserRole,
  updateRouList,
  rouList,
  roleMap,
  updateHospitalWardList,
  hospitalWardList,
  language,
  updateLoginInfo,
  setUnEdit,
  updateWardinfo,
  setNotificationTotal,
  notificationTotalRefresh,
  notificationSeenAndRefresh,
  setAppreciationTotal,
  setEnv
}) => {
  const classes = useStyles();
  const [confirmOpen, setConfirmOpen] = useState(true);
  const userInfo = useGetUserInfo();
  const mask = useSelector((state) => state.maskReducer);
  useBarcodeScanner();
  useLoadTranslations();
  const fullScreen = useSelector((state) => state.fullScreenReducer);
  useBsViewSetting();
  useUpdateOtherLoginInfo();
  const dispatch = useDispatch();

  useEffect(() => {
    if (fullScreen) {
      enterFullscreen();
    } else {
      exitFullscreen();
    }
  }, [fullScreen]);

  const getRoomTypeAPI = async () => {
    try {
      const { result } = await systemAPI.getNotificationRoomType();
      dispatch(InitForwardList(result));
    } catch (e) { }
  };

  useEffect(() => {
    (async () => {
      await getRoomTypeAPI();
    })();

    initBsAlereAudio();
  }, []);

  const getSysUserRole = async () => {
    try {
      const { result } = await systemAPI.getSysUserRole({ corpId: loginInfo.corpID });
      if (Array.isArray(result)) {
        updateHospitalWardList(null);
        updateUserRole(result);
      } else {
        updateHospitalWardList(null);
        updateUserRole([]);
      }
    } catch (error) {
      updateHospitalWardList(null);
      updateUserRole([]);
    }
  };

  const getHospitalWardList = async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList();
      updateUserRole(null);
      updateHospitalWardList([hospitalWardListFunc.getHospitalUseId(result, wardInfo.hospitalId)]);
    } catch { }
  };

  const userRoleRouList = () => {
    updateRouList(getRouterList(roleMapFunc.getExistMenuIds(roleMap)));
  };

  useEffect(() => {
    if (loginInfo.flag === false && wardInfo.flag === false) {
      userRoleRouList();
    } else if (loginInfo.flag) {
      (async () => {
        await getSysUserRole();
      })();
    } else {
      (async () => {
        await getHospitalWardList();
      })();
    }
  }, [loginInfo.flag, loginInfo.wardId, loginInfo.userId, loginInfo.hospitalId, wardInfo]);

  const handleRoleObj = ({ roleObj, hospWard }) => {
    if (roleObj) {
      if (loginInfo.wardId === roleObj.wardId) {
        updateRoleMap(hospWard, loginInfo.wardId, loginInfo.flag);
      } else {
        localStorage.setItem(LOGIN_INFO, JSON.stringify(roleObj));
        mutationUpdateOtherLoginInfo();
        updateLoginInfo(roleObj);
      }
    } else {
      localStorage.removeItem(LOGIN_INFO);
      mutationUpdateOtherLoginInfo();
      updateLoginInfo({ ...wardInfo, flag: false });
    }
  };

  useEffect(() => {
    if (Array.isArray(userRole)) {
      const hospWard = userRoleList.getHospWard(userRole, loginInfo.hospitalId, loginInfo.wardId, loginInfo.userId);
      const roleObj = userRoleFunc.updateLoginInfo(hospWard);
      if (userRoleFunc.getCorpId(hospWard)) {
        handleRoleObj({ roleObj, hospWard });
      } else {
        localStorage.removeItem(LOGIN_INFO);
        mutationUpdateOtherLoginInfo();
        updateLoginInfo({ ...wardInfo, flag: false });
      }
    } else if (Array.isArray(hospitalWardList)) {
      if (wardInfo.flag) {
        if (hospitalWardListFunc.isHospWardExist(hospitalWardList, wardInfo.hospitalId, wardInfo.wardId)) {
          updateRoleMap(
            hospitalWardListFunc.getHospitalUseId(hospitalWardList, wardInfo.hospitalId),
            wardInfo.wardId,
            loginInfo.flag
          );
        } else {
          localStorage.removeItem(WARD_INFO);
          updateWardinfo(false);
        }
      }
    }
  }, [userRole, hospitalWardList]);

  useEffect(() => {
    if (loginInfo.flag || wardInfo.flag) {
      if (loginInfo.flag) {
        if (Array.isArray(userRole)) {
          userRoleRouList();
        } else {
          updateRouList([]);
        }
      } else if (Array.isArray(hospitalWardList)) {
        userRoleRouList();
      } else {
        updateRouList([]);
      }
    }
  }, [roleMap]);

  // Check if the user is not init login
  useEffect(() => {
    checkRedirectUrl();
  }, []);

  useEffect(() => {
    (async () => {
      setEnv(await envFunc.getEnv());
    })();
  }, []);

  const getAppreciationTotal = async () => {
    try {
      const { result } = await patientSurveyAPI.getUnreadAppreciationCount(
        {
          sysRoleId: userInfo.roleId,
          corpId: loginInfo.corpID,
          type: "Appreciation"
        },
        { isHideLoading: true, isHideError: true }
      );
      setAppreciationTotal(result);
    } catch (error) { console.log('Get unread appreciation count error: ', error); }
  };

  useEffect(() => {
    if (Array.isArray(rouList) && rouList.length > 0) {
      checkIsNewDrive(userRole, rouList);
    }

    if (userInfo.roleTypeId && roleMap?.[authNameE.patient_survey]) {
      (async () => {
        await getAppreciationTotal();
      })();
      const timer = setInterval(() => {
        (async () => {
          await getAppreciationTotal();
        })();
      }, APPRECIATION_INTERVAL);

      return () => {
        clearInterval(timer);
      };
    }
  }, [rouList,roleMap]);

  const getNotificationTotal = async () => {
    try {
      const { result } = await systemAPI.getSysNotificationTotal(
        { roleTypeId: userInfo.roleTypeId, corpId: userInfo?.corpId ?? null },
        { isHideLoading: true }
      );
      setNotificationTotal(result.count);
    } catch (error) { }
  };

  const seenNotification = async () => {
    try {
      await systemAPI.seenSysNotification({ corpId: userInfo?.corpId ?? null }, { isHideLoading: true });
    } catch (error) {}
  };

  useEffect(() => {
    if (userInfo.roleTypeId || userInfo.wardId) {
      (async () => {
        await getNotificationTotal();
      })();
      const timer = setInterval(() => {
        (async () => {
          await getNotificationTotal();
        })();
      }, NOTIFICATION_INTERVAL);

      return () => {
        clearInterval(timer);
      };
    }
  }, [rouList, notificationTotalRefresh]);

  useEffect(() => {
    if (userInfo.roleTypeId && userInfo.wardId && userInfo.corpId) {
      (async () => {
        await seenNotification();
        await getNotificationTotal();
      })();
    }
  }, [notificationSeenAndRefresh]);

  useActionableAudioOpen();

  const getWorkflowList = useCallback(async () => {
    try {
      if (loginInfo.hospitalId) {
        const { result } = await eadmissionAPI.getWorkflowList({ hospId: loginInfo.hospitalId });
        if (result === null || JSON.stringify(result) === '{}') {
          dispatch(closeAdmissionWorkflow());
        } else {
          dispatch(openAdmissionWorkflow());
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [loginInfo]);

  useEffect(() => {
    getWorkflowList();
  }, [getWorkflowList]);

  return (
    <div className="ha-web-page">
      <audio
        id="actionable_alert"
        playsInline
        onEnded={() => {
          document.getElementById('actionable_alert').src = '';
        }}
      />
      <Router
        ref={(ref) => {
          ref && setRouterRef(ref);
        }}
        getUserConfirmation={(message, callback) => {
          return UserLeaveConfirmation(message, callback, confirmOpen, setConfirmOpen, setUnEdit);
        }}
      >
        <GlobalRouteChangeHandler />
        <Switch>
          {rouList.map((item, index) => {
            return <Route {...item} key={item.key} />;
          })}
        </Switch>
        <ServiceChecker />
      </Router>
      <Backdrop open={isLoading} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Backdrop open={mask} className={classes.backdrop} />
      <IdleChecker idleTimeThreshold={180000} activeTimeThreshold={60000} />
      <VersionChecker />
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.settings.language || 'en-us',
  isLoading: state.loading.isLoading,
  loginInfo: state.loginInfo,
  wardInfo: state.wardInfo,
  userRole: state.userRole,
  rouList: state.rouList,
  roleMap: state.roleMap,
  hospitalWardList: state.hospitalWardList,
  notificationTotalRefresh: state.notificationTotalRefresh,
  notificationSeenAndRefresh: state.notificationSeenAndRefresh,
});

export default connect(mapStateToProps, {
  screenResizeAction,
  updateWardinfo: updateWardinfoAction,
  updateUserRole: updateUserRoleAction,
  updateRouList: updateRouListAction,
  initLoginInfo: initLoginInfoAction,
  updateRoleMap: updateRoleMapAction,
  updateHospitalWardList: updateHospitalWardListAction,
  updateLoginInfo: updateLoginInfoAction,
  setUnEdit: SetUnEdit,
  setNotificationTotal: SetNotificationTotal,
  setAppreciationTotal: SetAppreciationTotal,
  setEnv: setEnv
})(App);
